export default __webpack_public_path__ + "static/media/TopImage-poster.a478512f.jpg";